import { Injectable } from '@angular/core';
import { WindowService } from 'shared/services/window/window.service';
import { NotificationResult } from 'shared/models/notification/notification-result.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerService {
  private static serviceWorkerRegistration: ServiceWorkerRegistration;

  public static setRegistration(registration: ServiceWorkerRegistration): void {
    this.serviceWorkerRegistration = registration;
  }

  constructor(private _windowService: WindowService) {
  }

  public supportsNotifications(): boolean {
    return !!ServiceWorkerService.serviceWorkerRegistration && ('showNotification' in ServiceWorkerService.serviceWorkerRegistration);
  }

  public sendNotification(title: string, options: NotificationOptions): Promise<NotificationResult> {
    if (!this.supportsNotifications()) {
      return Promise.resolve({ type: 'failed' });
    }

    return this.sendMessage({
      type: 'sendNotification',
      data: {
        title,
        options
      }
    });
  }

  private sendMessage(message: any): Promise<any> {
    const win = this._windowService.getWindow();
    return new Promise((resolve, reject) => {
      const messageChannel = new win.MessageChannel();
      messageChannel.port1.onmessage = event => {
        if (event.data.error) {
          reject(event.data.error);
        } else {
          resolve(event.data);
        }
      };

      ServiceWorkerService.serviceWorkerRegistration.active.postMessage(message, [messageChannel.port2]);
    });
  }
}
